import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.4_eslint@9.27.0_rollup@4.41.1_sass@1.89.0_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}